import Vue from "vue";
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "pWalletMenu",
  computed: {
    ...walletVuex.mapState(["isMobile", "address", "netId"])
  },
  data() {
    const menu = [{
      label: this.$lang("Copy Address"),
      value: "copy",
      icon: "copy"
    }, {
      label: this.$lang("Explorer"),
      value: "explorer",
      icon: "explorer"
    }, {
      label: this.$lang("Switch network"),
      value: "switchnetwork",
      icon: "icon-conversion"
    }, {
      label: this.$lang("Disconnect"),
      value: "disconnect",
      icon: "disconnect"
    }];
    return {
      menu
    };
  },
  methods: {
    ...walletVuex.mapActions(["disConnect"]),
    onSkip(item) {
      switch (item.value) {
        case "copy":
          this.$copyText(this.address).then(this.$toasted.success("Copyed!"));
          break;
        case "disconnect":
          this.web3Wallet.disConnect();
          this.$toasted.clear();
          this.$toasted.info("Disconnected!");
          this.$parent.pWalletMenuShow = false;
          break;
        case "switchnetwork":
          this.web3Wallet.modal.open({
            view: "Networks"
          });
          this.$parent.pWalletMenuShow = false;
          break;
        case "explorer":
          open(`${this.web3Wallet.explorer.url}/address/${this.address}`, "target");
          break;
      }
    }
  }
};